import type { FC, ReactNode } from 'react'

import { Plus } from 'lucide-react'
import { Eyebrow } from '@/components/landing/eyebrow'
import { FAQS } from '@/constants/event'

export const FaqSection: FC = (): ReactNode => {
    return (
        <section
            id='faq'
            aria-labelledby='faq-title'
            className='relative bg-cream text-ink'
        >
            <div className='mx-auto grid max-w-[1440px] gap-12 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12'>
                <div className='lg:col-span-4'>
                    <Eyebrow className='text-court'>Questions</Eyebrow>

                    <h2 id='faq-title' className='mt-5 font-heading text-[clamp(3rem,6vw,5.75rem)] font-black uppercase leading-[0.86]'>
                        Good to know
                        <span className='serif-soft block font-serif font-normal normal-case italic text-court'>before you go.</span>
                    </h2>
                </div>

                <div className='border-t border-ink/15 lg:col-span-8'>
                    {FAQS.map((faq) => (
                        <details key={faq.question} className='group border-b border-ink/15'>
                            <summary className='flex min-h-16 cursor-pointer list-none items-center justify-between gap-6 py-5 text-left focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-court [&::-webkit-details-marker]:hidden'>
                                <span className='font-heading text-2xl font-bold uppercase leading-tight md:text-3xl'>
                                    {faq.question}
                                </span>

                                <span aria-hidden='true' className='inline-flex size-10 shrink-0 items-center justify-center rounded-full border border-ink/20 transition-[transform,background-color] duration-300 group-open:rotate-45 group-open:bg-lime motion-reduce:transition-none'>
                                    <Plus className='size-4' />
                                </span>
                            </summary>

                            <p className='max-w-2xl pb-7 pr-14 text-base leading-relaxed text-ink/75'>
                                {faq.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}
